export const ORGANIZATION_PERMISSIONS = {
  UPDATE_SUBSCRIPTION_PLAN: 'update_subscription_plan',
  MANAGE_SUBSCRIPTION_CART: 'manage_subscription_cart',
  COMPLETE_SUBSCRIPTION_CHECKOUT: 'complete_subscription_checkout',
  READ: 'read',
} as const;

export const EVENT_PERMISSIONS = {
  INVITE_CONTRIBUTORS: 'invite_contributors',
  CREATE_ORDER: 'create_order',
  COMPLETE_ORDER: 'complete_order',
  MANAGE_EVENT_ROLES: 'manage_event_roles',
  MANAGE_EVENT_MANAGERS: 'manage_event_managers',
  MANAGE_EVENT_OWNERS: 'manage_event_owners',
  UPDATE_SUBSCRIPTION_PLAN: 'update_subscription_plan',
} as const;

export const CONTRIBUTOR_PERMISSIONS = {
  DELETE_CONTRIBUTOR: 'delete',
  UPDATE_CONTRIBUTOR: 'update',
} as const;

export const PERMISSIONS = {
  ...ORGANIZATION_PERMISSIONS,
  ...EVENT_PERMISSIONS,
  ...CONTRIBUTOR_PERMISSIONS,
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
